// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopArticleTaxByIdRequestModel from '../../model/get-shop-article-tax-by-id-request-model';
import GetShopArticleTaxByIdRequestDTO from '../dto/get-shop-article-tax-by-id-request-dto';
import dtoSchema from '../schemas/get-shop-article-tax-by-id-request-schema';

export default abstract class GetShopArticleTaxByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopArticleTaxByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetShopArticleTaxByIdRequestDTO>): GetShopArticleTaxByIdRequestModel;
  static toModel(dto: DeepPartial<GetShopArticleTaxByIdRequestDTO> | undefined | null): GetShopArticleTaxByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopArticleTaxByIdRequestDTO> | undefined | null): GetShopArticleTaxByIdRequestModel | undefined {
    return dto ? new GetShopArticleTaxByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopArticleTaxByIdRequestModel> | GetShopArticleTaxByIdRequestModel): GetShopArticleTaxByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetShopArticleTaxByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopArticleTaxByIdRequestModel, can not map to GetShopArticleTaxByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
